import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BrandService } from 'src/app/configuration/services/brand.service';
import { Brand } from '../../models/brand';
import { BranchControllerService, ProductControllerService as FalconProductControllerService } from "falcon-api";
import { Product } from "../../../shared/models/product";
import { ApplicationStatus, Branch, Channel, Ownership, RcCode } from 'src/app/application/applications.component';
import { ReferenceCode } from '../../models/reference-code';
import { MatSelectionListChange } from '@angular/material/list';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationService } from 'src/app/application/application.service';

@Component({
  selector: 'app-custom-filter',
  templateUrl: './custom-filter.component.html',
  styleUrls: ['./custom-filter.component.scss']
})
export class CustomFilterComponent implements OnInit, OnChanges {

  @Output() applyFilters: EventEmitter<any> = new EventEmitter();
  @Output() clearFilters: EventEmitter<any> = new EventEmitter();
  isOpen = false;
  panelOpenState = false;
  brands: Array<Brand> = [];
  products: Array<Product> = [];
  filteredBrand: any[] = [];
  filteredProduct: any[] = [];
  filteredBranch: any[] = [];
  filteredApplication: any[] = [];
  filteredChannel: any[] = [];
  filteredOwnership: any[] = [];
  filteredReferenceCode: any[] = [];
  filteredProductsByBrand: Product[] = [];
  selectedBrandNames: any[] = [];
  selectedBrandValues: any[] = [];
  selectedProductValues: any[] = [];
  selectedProductNames: any[] = [];
  selectedBranchNames: any[] = [];
  selectedBranchValues: any[] = [];
  selectedApplicationName: any[] = [];
  selectedApplicationValues: any[] = [];
  selectedChannelName: any[] = [];
  selectedChannelValuese: any[] = [];
  selectedOwnershipName: any[] = [];
  selectedOwnershipValues: any[] = [];
  selectedReferenceName: any[] = [];
  selectedReferenceValues: any[] = [];
  selectedBranchName: any[] = [];
  branchList: Branch[] = [];
  applicationStatus: ApplicationStatus[] = [];
  channels: Channel[] = [];
  ownerships: Ownership[] = [];
  referenceCodes: RcCode[] = [];
  finalFilterObject: any[] = [];

  customFilterForm = this.formBuilder.group({
    brandOperator: [''],
    brandCriteria: [''],
    productOperator: [''],
    productCriteria: [''],
    branchOperator: [''],
    branchCriteria: [''],
    applicationOperator: [''],
    applicationCriteria: [''],
    channelOperator: [''],
    channelCriteria: [''],
    ownershipOperator: [''],
    ownershipCriteria: [''],
    referenceOperator: [''],
    referenceCriteria: [''],
  });

  @Input() fieldName = '';

  constructor(private brandService: BrandService,
    private branchService: BranchControllerService,
    private formBuilder: FormBuilder,
    private falconProductService: FalconProductControllerService,
    public appService: ApplicationService) { }

  ngOnInit(): void {

    this.getBrands();
    this.loadProduct();
    this.loadBranchDetails();
    this.setupApplicationStatus();
    this.setupChannels();
    this.setupOwnerships();
    this.setupReferenceCodes();

    if(this.appService.appliedFilterData && this.appService.appliedFilterData.length > 0) {
      this.appService.isFilterApplied = true;
      this.appService.appliedFilterData.forEach( (data: {
        operatorDescription: any;
        criteria: any; field: any;
        }) => {
        if(data.field == 'brand') {
          this.filteredBrand.push(data);
          this.customFilterForm.get('brandOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('brandCriteria')?.setValue(data.criteria);
        }

        if(data.field == 'productCode') {
          this.filteredProduct.push(data);
          this.customFilterForm.get('productOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('productCriteria')?.setValue(data.criteria);
        }

        if(data.field == 'branch') {
          this.filteredBranch.push(data);
          this.customFilterForm.get('branchOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('branchCriteria')?.setValue(data.criteria);
        }

        if(data.field == 'status') {
          this.filteredApplication.push(data);
          this.customFilterForm.get('applicationOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('applicationCriteria')?.setValue(data.criteria);
        }

        if(data.field == 'applicationChannelId') {
          this.filteredChannel.push(data);
          this.customFilterForm.get('channelOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('channelCriteria')?.setValue(data.criteria);
        }

        if(data.field == 'isJoint') {
          this.filteredOwnership.push(data);
          this.customFilterForm.get('ownershipOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('ownershipCriteria')?.setValue(data.criteria);
        }

        if(data.field == 'rcCode') {
          this.filteredReferenceCode.push(data);
          this.customFilterForm.get('referenceOperator')?.setValue(data.operatorDescription);
          this.customFilterForm.get('referenceCriteria')?.setValue(data.criteria);
        }

      });

    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // once user remove singal filter from list of filters then updating those changes into form as well to synchup with current filter steps
    if (this.fieldName == 'brand') {
      this.customFilterForm.get('brandOperator')?.setValue('');
      this.customFilterForm.get('brandCriteria')?.setValue('');
    }

    if (this.fieldName == 'productCode') {
      this.customFilterForm.get('productOperator')?.setValue('');
      this.customFilterForm.get('productCriteria')?.setValue('');
    }

    if (this.fieldName == 'branch') {
      this.customFilterForm.get('branchOperator')?.setValue('');
      this.customFilterForm.get('branchCriteria')?.setValue('');
    }

    if (this.fieldName == 'status') {
      this.customFilterForm.get('applicationOperator')?.setValue('');
      this.customFilterForm.get('applicationCriteria')?.setValue('');
    }

    if (this.fieldName == 'applicationChannelId') {
      this.customFilterForm.get('channelOperator')?.setValue('');
      this.customFilterForm.get('channelCriteria')?.setValue('');
    }

    if (this.fieldName == 'isJoint') {
      this.customFilterForm.get('ownershipOperator')?.setValue('');
      this.customFilterForm.get('ownershipCriteria')?.setValue('');
    }

    if (this.fieldName == 'rcCode') {
      this.customFilterForm.get('referenceOperator')?.setValue('');
      this.customFilterForm.get('referenceCriteria')?.setValue('');
    }

  }

  private getBrands() {
    this.brandService.getBrands().then((brands) => {
      this.brands = brands.sort((a, b) => a.id - b.id);
    }
    );
  }

  private loadProduct() {
    this.filteredProductsByBrand = [];
    this.falconProductService.getProducts().subscribe(productDetails => {
      productDetails.sort((a: any, b: any) => b?.code > a?.code ? -1 : 1).forEach(productDetail => {
        if (productDetail.enabled) {
          let product = Product.mapFromDto(productDetail);
        this.products.push(product);
        if (this.selectedProductValues! && this.selectedProductValues.includes(product.productUID)) {
          this.selectedProductNames.push(product.code + ' - ' + product.name + '  (' + product.brandName + ')');
        }
        this.filteredProductsByBrand.push(product);
        }

      });
    });
  }

  loadBranchDetails() {
    this.branchService.getBranches().subscribe(result => {
      result.sort((a: any, b: any) => b?.branchName > a?.branchName ? -1 : 1).forEach(branch => {
        this.branchList.push({ displayText: branch.branchName?.trim() + ' Banking Center', value: branch.branchId!, branchCity: branch.branchCity! })
      });
    });
  }

  private setupOwnerships() {
    this.ownerships.push({ displayText: "Single", value: "0" });
    this.ownerships.push({ displayText: "Joint", value: "1" });
  }

  private setupReferenceCodes() {
    this.referenceCodes.push({ displayText: "RC200 (Alloy - Under Review)", value: ReferenceCode.AlloyUnderReview.toString() });
    this.referenceCodes.push({ displayText: "RC201 (DocV - Under Review)", value: ReferenceCode.DocVUnderReview.toString() });
    this.referenceCodes.push({ displayText: "RC210 (Fiserv - Enrollment Failure)", value: ReferenceCode.FiservEnrollmentFailure.toString() });
    this.referenceCodes.push({ displayText: "RC211 (Fiserv - Joint Enrollment Failure)", value: ReferenceCode.JointAccountFailure.toString() });
    this.referenceCodes.push({ displayText: "RC220 (Online Banking - Enrollment Failure)", value: ReferenceCode.OnlineBankingEnrollmentFailure.toString() });
    this.referenceCodes.push({ displayText: "RC230 (Unexpected Enrollment Failure)", value: ReferenceCode.UnderReviewFailure.toString() });
    this.referenceCodes.push({ displayText: "RC300 (Alloy - Denied)", value: ReferenceCode.AlloyDenied.toString() });
    this.referenceCodes.push({ displayText: "RC301 (DocV - Denied)", value: ReferenceCode.DocVDenied.toString() });
    this.referenceCodes.push({ displayText: "RC303 (Alloy - Qualifile Decline)", value: ReferenceCode.AlloyQualifileDecline.toString() });
    this.referenceCodes.push({ displayText: "RC310 (Customer Not in Good Standing)", value: ReferenceCode.StatusUFailure.toString() });
    this.referenceCodes.push({ displayText: "RC330 (Eligibility Review Failure)", value: ReferenceCode.EligibilityReviewFailure.toString() });
    this.referenceCodes.push({ displayText: "RC340 (Unexpected Failure)", value: ReferenceCode.InternalFailure.toString() });
    this.referenceCodes.push({ displayText: "RC350 (Alloy - Unexpected Failure)", value: ReferenceCode.AlloyFailure.toString() });
    this.referenceCodes.push({ displayText: "RC351 (DocV - Unexpected Failure)", value: ReferenceCode.DocVFailure.toString() });
    this.referenceCodes.push({ displayText: "RC360 (Document Capture - Unexpected Failure)", value: ReferenceCode.SocureFailure.toString() });
    this.referenceCodes.push({ displayText: "RC370 (Eligibility Review - OFAC Rejected)", value: ReferenceCode.EligibilityFailure.toString() });
    this.referenceCodes.push({ displayText: "RC380 (Application - Invalid SSN / Email Combination)", value: ReferenceCode.EMailSSNCombinationInvalid.toString() });
    this.referenceCodes.push({ displayText: "RC390 (Eligibility Review - Applicant Info Mismatch)", value: ReferenceCode.ApplicantInfoMismatch.toString() });
    this.referenceCodes.push({ displayText: "RC400 (Eligibility Review - Product Rules Failure)", value: ReferenceCode.ProductCheckFailure.toString() });
    this.referenceCodes.push({ displayText: "RC401 (Eligibility Review - Account Rules Failure)", value: ReferenceCode.AccountRulesFailure.toString() });
    this.referenceCodes.push({ displayText: "RC402 (Eligibility Review - HYSA Account Rules Failure)", value: ReferenceCode.HYSAAccountRulesFailure.toString() });
  }

  private setupChannels() {
    this.channels.push({ displayText: "Digital Self-Serve (BB8)", value: "1" });
    this.channels.push({ displayText: "Banking Center (BB8)", value: "2" });
    this.channels.push({ displayText: "FSR/RM Assisted (Coruscant)", value: "3" });
    this.channels.push({ displayText: "OLB - Joint Request", value: "4" });
    this.channels.push({ displayText: "CSR - Joint Request", value: "5" });
    this.channels.push({ displayText: "OLB - Authenticated", value: "6" });
  }

  private setupApplicationStatus() {
    this.applicationStatus.push({ displayText: "Created", value: "Created" });
    this.applicationStatus.push({ displayText: "Started", value: "Started" });
    this.applicationStatus.push({ displayText: "Abandoned", value: "Abandoned" });
    this.applicationStatus.push({ displayText: "Approved", value: "Approved" });
    this.applicationStatus.push({ displayText: "Under Review", value: "Under Review" });
    this.applicationStatus.push({ displayText: "Rejected", value: "Rejected" });
    this.applicationStatus.push({ displayText: "Review Closed", value: "Review Closed" });
    this.applicationStatus.push({ displayText: "Expired", value: "Expired" });
    this.applicationStatus.push({ displayText: "Error", value: "Error" });
    this.applicationStatus.push({displayText: "Pending", value: "Pending"});
    this.applicationStatus.sort((state1, state2) => (state1.displayText < state2.displayText) ? -1 : 1);
  }


  onBrandSelected(event: any, value: any) {
    this.customFilterForm.get('brandCriteria')?.enable();
    this.selectedBrandValues = [];
    this.selectedBrandNames = [];
    this.filteredBrand = [];
    let field = "brand";
    let fieldDescription = "Brand";
    let operator = this.customFilterForm.get('brandOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('brandOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";

    for (let i = 0; i < value.length; i++) {
      this.selectedBrandValues.push(value[i]._value);
      this.selectedBrandNames.push(value[i]._text.nativeElement.innerText);
    }
    let criteriaDisplayText = this.selectedBrandNames.toString();
    let criteria = this.selectedBrandValues;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredBrand.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
    this.loadFilteredProducts();
    console.log('filteredBrand', this.filteredBrand);
  }

  loadFilteredProducts() {
    let selectedBrandValues: any[] = [];
    if (this.selectedBrandValues.length > 0) {
      this.filteredProductsByBrand = [];
      selectedBrandValues = this.brands.filter(brand => this.selectedBrandValues.includes(brand.id));
      this.products.forEach(product => {
        selectedBrandValues.forEach((val: any) => {
          if (product.brandId === val.id)
            this.filteredProductsByBrand.push(product);
        });
      });
    } else {
      this.filteredProductsByBrand = this.products;
    }
  }

  onProductSelected(event: any, value: any) {
    this.customFilterForm.get('productCriteria')?.enable();
    this.selectedProductValues = [];
    this.selectedProductNames = [];
    this.filteredProduct = [];
    let field = "productCode";
    let fieldDescription = "Product";
    let operator = this.customFilterForm.get('productOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('productOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";
    for (let i = 0; i < value.length; i++) {
      this.selectedProductValues.push(value[i]._value);
      this.selectedProductNames.push(value[i]._text.nativeElement.innerText);
    }
    let criteriaDisplayText = this.selectedProductValues.toString();
    let criteria = this.selectedProductValues;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredProduct.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
  }

  onBranchSelected(value: any) {
    this.customFilterForm.get('branchCriteria')?.enable();
    this.selectedBranchValues = [];
    this.selectedBranchNames = [];
    this.filteredBranch = [];
    let field = "branch";
    let fieldDescription = "Branch";
    let operator = this.customFilterForm.get('branchOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('branchOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";
    for (let i = 0; i < value.length; i++) {
      this.selectedBranchValues.push(value[i]._value);
      this.selectedBranchNames.push(value[i]._text.nativeElement.innerText);
    }

    let criteriaDisplayText = this.selectedBranchNames.toString();
    let criteria = this.selectedBranchValues;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredBranch.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
  }

  onApplicationSelected(value: any) {
    this.customFilterForm.get('applicationCriteria')?.enable();
    this.selectedApplicationValues = [];
    this.selectedApplicationName = [];
    this.filteredApplication = [];
    let field = "status";
    let fieldDescription = "Application Status";
    let operator = this.customFilterForm.get('applicationOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('applicationOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";
    for (let i = 0; i < value.length; i++) {
      this.selectedApplicationValues.push(value[i]._value);
      this.selectedApplicationName.push(value[i]._text.nativeElement.innerText);
    }

    let criteriaDisplayText = this.selectedApplicationName.toString();
    let criteria = this.selectedApplicationValues;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredApplication.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
  }

  onChannelSelected(value: any) {
    this.customFilterForm.get('channelCriteria')?.enable();
    this.selectedChannelValuese = [];
    this.selectedChannelName = [];
    this.filteredChannel = [];
    let field = "applicationChannelId";
    let fieldDescription = "Channel";
    let operator = this.customFilterForm.get('channelOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('channelOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";
    for (let i = 0; i < value.length; i++) {
      this.selectedChannelValuese.push(value[i]._value);
      this.selectedChannelName.push(value[i]._text.nativeElement.innerText);
    }

    let criteriaDisplayText = this.selectedChannelName.toString();
    let criteria = this.selectedChannelValuese;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredChannel.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
  }

  onOwnershipSelected(value: any) {
    this.customFilterForm.get('ownershipCriteria')?.enable();
    this.selectedOwnershipValues = [];
    this.selectedOwnershipName = [];
    this.filteredOwnership = [];
    let field = "isJoint";
    let fieldDescription = "Ownership";
    let operator = this.customFilterForm.get('ownershipOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('ownershipOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";
    for (let i = 0; i < value.length; i++) {
      this.selectedOwnershipValues.push(value[i]._value);
      this.selectedOwnershipName.push(value[i]._text.nativeElement.innerText);
    }

    let criteriaDisplayText = this.selectedOwnershipName.toString();
    let criteria = this.selectedOwnershipValues;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredOwnership.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
  }

  onReferenceSelected(value: any) {
    this.customFilterForm.get('referenceCriteria')?.enable();
    this.selectedReferenceValues = [];
    this.selectedReferenceName = [];
    this.filteredReferenceCode = [];
    let field = "rcCode";
    let fieldDescription = "Reference Code";
    let operator = this.customFilterForm.get('referenceOperator')?.value == 'is not equal to' ? '!' : ":";
    let operatorDescription = this.customFilterForm.get('referenceOperator')?.value;
    if(!operatorDescription) operatorDescription = "is equal to";
    for (let i = 0; i < value.length; i++) {
      this.selectedReferenceValues.push(value[i]._value);
      this.selectedReferenceName.push(value[i]._text.nativeElement.innerText);
    }

    let criteriaDisplayText = this.selectedReferenceName.toString();
    let criteria = this.selectedReferenceValues;
    let description = `${fieldDescription} ${operatorDescription} ${criteria.toString()}`;
    this.filteredReferenceCode.push({ field, fieldDescription, operator, operatorDescription, criteria, description, criteriaDisplayText });
  }

  applyFilter() {
    if (this.customFilterForm.value.brandCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredBrand[this.filteredBrand.length - 1]);
    }

    if (this.customFilterForm.value.productCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredProduct[this.filteredProduct.length - 1]);
    }

    if (this.customFilterForm.value.branchCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredBranch[this.filteredBranch.length - 1]);
    }

    if (this.customFilterForm.value.applicationCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredApplication[this.filteredApplication.length - 1]);
    }

    if (this.customFilterForm.value.channelCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredChannel[this.filteredChannel.length - 1]);
    }

    if (this.customFilterForm.value.ownershipCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredOwnership[this.filteredOwnership.length - 1]);
    }

    if (this.customFilterForm.value.referenceCriteria.length > 0) {
      this.finalFilterObject.push(this.filteredReferenceCode[this.filteredReferenceCode.length - 1]);
    }

    if (this.finalFilterObject.length > 0) {
      this.applyFilters.emit(this.finalFilterObject);
    }

    this.isOpen = false;
    this.finalFilterObject = [];
  }

  onClear() {
    this.customFilterForm.reset();
    this.finalFilterObject = [];
  }

  clearAllFilter() {
    this.clearFilters.emit();
    this.onClear();
    this.intilizeForm();
  }

  intilizeForm() {
    this.customFilterForm = this.formBuilder.group({
      brandOperator: [''],
      brandCriteria: [''],
      productOperator: [''],
      productCriteria: [''],
      branchOperator: [''],
      branchCriteria: [''],
      applicationOperator: [''],
      applicationCriteria: [''],
      channelOperator: [''],
      channelCriteria: [''],
      ownershipOperator: [''],
      ownershipCriteria: [''],
      referenceOperator: [''],
      referenceCriteria: [''],
    });
  }

}
